export type ThinkingOrbState =
	| "working"
	| "searching"
	| "solving"
	| "listening"
	| "composing"
	| "shaping"

const STATE_PATTERNS: [RegExp, ThinkingOrbState][] = [
	[/search|find|look|read|brows|fetch|retriev|scan/i, "searching"],
	[/draft|writ|compos|generat|repl|summar/i, "composing"],
	[/solv|analy|reason|comput|calculat|evaluat|figur/i, "solving"],
	[/listen|transcri|hear/i, "listening"],
	[/shap|format|structur|organ|build|creat/i, "shaping"],
]

/**
 * Maps an AI wait-action label to a thinking-orb animation state.
 * Best-effort English keyword match; falls back to "working".
 */
export const pickOrbState = (label?: string | null): ThinkingOrbState => {
	if (!label) return "working"
	for (const [pattern, state] of STATE_PATTERNS) {
		if (pattern.test(label)) return state
	}
	return "working"
}
